__turbopack_context__.v({
  "embed": "BlogMdxYouTube-module-scss-module__-ujYZa__embed",
  "enter": "BlogMdxYouTube-module-scss-module__-ujYZa__enter",
  "exit": "BlogMdxYouTube-module-scss-module__-ujYZa__exit",
  "fade-in": "BlogMdxYouTube-module-scss-module__-ujYZa__fade-in",
  "fade-out": "BlogMdxYouTube-module-scss-module__-ujYZa__fade-out",
  "fade-out-80": "BlogMdxYouTube-module-scss-module__-ujYZa__fade-out-80",
  "iframe": "BlogMdxYouTube-module-scss-module__-ujYZa__iframe",
  "slide-in-from-bottom": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-in-from-bottom",
  "slide-in-from-left": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-in-from-left",
  "slide-in-from-right": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-in-from-right",
  "slide-in-from-top": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-in-from-top",
  "slide-out-to-bottom": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-out-to-bottom",
  "slide-out-to-left": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-out-to-left",
  "slide-out-to-right": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-out-to-right",
  "slide-out-to-top": "BlogMdxYouTube-module-scss-module__-ujYZa__slide-out-to-top",
  "zoom-in": "BlogMdxYouTube-module-scss-module__-ujYZa__zoom-in",
  "zoom-out": "BlogMdxYouTube-module-scss-module__-ujYZa__zoom-out",
});
